import { Modal } from "@4uhub/lib4uhub";
import { memo } from "react";
import { WhatsappProfileForm } from "./WhatsappProfileForm";

export const WhatsappProfileModal = memo(
  ({ open, closeHandler }: { open: boolean; closeHandler: () => void }) => {
    return (
      <>
        <Modal onClose={closeHandler} open={open}>
          <WhatsappProfileForm onClose={closeHandler}></WhatsappProfileForm>
        </Modal>
      </>
    );
  }
);
